var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1Teacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 315,
    viewBox: "0 0 391 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.753 314.716C235.252 317.804 215.938 276.066 120.496 293.408C44.3902 307.233 11.6267 255.613 2.14939 223.544C-2.37385 208.222 -3.52261 148.335 38.2396 147.48C179.968 144.535 293.527 -10.6808 361.855 125.056C389.569 180.12 433.102 307.684 295.753 314.716Z",
    fill: "#F0FDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_284)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.596 109.189H155.005V135.781H238.596V109.189Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.581 135.78H109.99L108.364 131.15C106.403 125.548 106.403 119.437 108.364 113.836L109.99 109.205H193.581L191.955 113.836C189.994 119.437 189.994 125.548 191.955 131.15L193.581 135.78Z",
    fill: "#88BDFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.295 109.189H190.951C190.141 109.189 189.484 109.845 189.484 110.653V112.468C189.484 113.276 190.141 113.932 190.951 113.932H242.295C243.105 113.932 243.761 113.276 243.761 112.468V110.653C243.761 109.845 243.105 109.189 242.295 109.189Z",
    fill: "#88BDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.295 131.039H190.951C190.141 131.039 189.484 131.694 189.484 132.503V134.317C189.484 135.125 190.141 135.781 190.951 135.781H242.295C243.105 135.781 243.761 135.125 243.761 134.317V132.503C243.761 131.694 243.105 131.039 242.295 131.039Z",
    fill: "#88BDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.656 136.258H169.065V162.849H252.656V136.258Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.64 162.849H124.049L122.423 158.219C120.462 152.617 120.462 146.506 122.423 140.905L124.049 136.274H207.64L206.014 140.905C204.054 146.506 204.054 152.617 206.014 158.219L207.64 162.849Z",
    fill: "#64A6FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.354 136.258H205.01C204.2 136.258 203.544 136.913 203.544 137.722V139.536C203.544 140.345 204.2 141 205.01 141H256.354C257.164 141 257.821 140.345 257.821 139.536V137.722C257.821 136.913 257.164 136.258 256.354 136.258Z",
    fill: "#64A6FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.354 158.107H205.01C204.2 158.107 203.544 158.762 203.544 159.571V161.385C203.544 162.194 204.2 162.849 205.01 162.849H256.354C257.164 162.849 257.821 162.194 257.821 161.385V159.571C257.821 158.762 257.164 158.107 256.354 158.107Z",
    fill: "#64A6FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 162.849H119.411L117.785 158.219C115.824 152.617 115.824 146.506 117.785 140.905L119.411 136.274H203.002L201.376 140.905C199.415 146.506 199.415 152.617 201.376 158.219L203.002 162.849H202.986Z",
    fill: "#00519E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.793 82.1357H175.202V108.727H258.793V82.1357Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.778 108.728H130.187L128.561 104.097C126.6 98.4954 126.6 92.3847 128.561 86.7832L130.187 82.1523H213.778L212.152 86.7832C210.192 92.3847 210.192 98.4954 212.152 104.097L213.778 108.728Z",
    fill: "#00519E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.491 82.1357H211.147C210.337 82.1357 209.681 82.7912 209.681 83.5998V85.4139C209.681 86.2225 210.337 86.8779 211.147 86.8779H262.491C263.301 86.8779 263.958 86.2225 263.958 85.4139V83.5998C263.958 82.7912 263.301 82.1357 262.491 82.1357Z",
    fill: "#00519E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.123 108.728H125.547L123.922 104.097C121.961 98.4954 121.961 92.3847 123.922 86.7832L125.547 82.1523H209.139L207.513 86.7832C205.552 92.3847 205.552 98.4954 207.513 104.097L209.139 108.728H209.123Z",
    fill: "#00305E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.425 55.083H185.834V81.6743H269.425V55.083Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.41 81.675H140.819L139.193 77.0442C137.232 71.4427 137.232 65.3319 139.193 59.7304L140.819 55.0996H224.41L222.784 59.7304C220.823 65.3319 220.823 71.4427 222.784 77.0442L224.41 81.675Z",
    fill: "#88BDFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.124 55.083H221.78C220.97 55.083 220.313 55.7385 220.313 56.547V58.3612C220.313 59.1697 220.97 59.8252 221.78 59.8252H273.124C273.934 59.8252 274.59 59.1697 274.59 58.3612V56.547C274.59 55.7385 273.934 55.083 273.124 55.083Z",
    fill: "#88BDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.124 76.9321H221.78C220.97 76.9321 220.313 77.5876 220.313 78.3962V80.2103C220.313 81.0189 220.97 81.6743 221.78 81.6743H273.124C273.934 81.6743 274.59 81.0189 274.59 80.2103V78.3962C274.59 77.5876 273.934 76.9321 273.124 76.9321Z",
    fill: "#88BDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.755 81.675H136.163L134.537 77.0442C132.577 71.4427 132.577 65.3319 134.537 59.7304L136.163 55.0996H219.755L218.129 59.7304C216.168 65.3319 216.168 71.4427 218.129 77.0442L219.755 81.675Z",
    fill: "#64A6FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.062 31.9453H167.471V54.606H251.062V31.9453Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.046 54.6057H122.455L120.829 49.9749C118.868 44.3734 118.868 38.2626 120.829 32.6611L122.455 28.0303H206.046L204.42 32.6611C202.46 38.2626 202.46 44.3734 204.42 49.9749L206.046 54.6057Z",
    fill: "#006CFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.038 20.7903L201.949 32.5663C200.754 32.5663 199.798 31.5796 199.798 30.3543V30.0201C199.798 28.7948 200.754 27.8082 201.949 27.8082L253.038 16.0322C254.234 16.0322 255.19 17.0189 255.19 18.2442V18.5784C255.19 19.8037 254.234 20.7903 253.038 20.7903Z",
    fill: "#006CFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.76 49.8638H203.416C202.606 49.8638 201.95 50.5192 201.95 51.3278V53.1419C201.95 53.9505 202.606 54.606 203.416 54.606H254.76C255.57 54.606 256.227 53.9505 256.227 53.1419V51.3278C256.227 50.5192 255.57 49.8638 254.76 49.8638Z",
    fill: "#006CFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.392 54.6057H117.801L116.175 49.9749C114.214 44.3734 114.214 38.2626 116.175 32.6611L117.801 28.0303H201.392L199.766 32.6611C197.806 38.2626 197.806 44.3734 199.766 49.9749L201.392 54.6057Z",
    fill: "#00305E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.8 28.0146H201.392L253.038 16.0477L178.039 16L117.8 28.0146Z",
    fill: "#00519E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.714 217.496H164.123V244.087H247.714V217.496Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.699 244.087H119.108L117.482 239.456C115.521 233.855 115.521 227.744 117.482 222.143L119.108 217.512H202.699L201.073 222.143C199.113 227.744 199.113 233.855 201.073 239.456L202.699 244.087Z",
    fill: "#88BDFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.413 217.496H200.069C199.259 217.496 198.603 218.151 198.603 218.96V220.774C198.603 221.582 199.259 222.238 200.069 222.238H251.413C252.223 222.238 252.88 221.582 252.88 220.774V218.96C252.88 218.151 252.223 217.496 251.413 217.496Z",
    fill: "#88BDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.413 239.345H200.069C199.259 239.345 198.603 240 198.603 240.809V242.623C198.603 243.431 199.259 244.087 200.069 244.087H251.413C252.223 244.087 252.88 243.431 252.88 242.623V240.809C252.88 240 252.223 239.345 251.413 239.345Z",
    fill: "#88BDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.044 244.087H114.452L112.827 239.456C110.866 233.855 110.866 227.744 112.827 222.143L114.452 217.512H198.044L196.418 222.143C194.457 227.744 194.457 233.855 196.418 239.456L198.044 244.087Z",
    fill: "#64A6FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.774 244.548H178.183V271.14H261.774V244.548Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.758 271.156H133.167L131.541 266.525C129.58 260.924 129.58 254.813 131.541 249.211L133.167 244.581H216.758L215.132 249.211C213.172 254.813 213.172 260.924 215.132 266.525L216.758 271.156Z",
    fill: "#64A6FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.472 244.548H214.128C213.318 244.548 212.662 245.204 212.662 246.012V247.827C212.662 248.635 213.318 249.291 214.128 249.291H265.472C266.282 249.291 266.939 248.635 266.939 247.827V246.012C266.939 245.204 266.282 244.548 265.472 244.548Z",
    fill: "#64A6FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.472 266.414H214.128C213.318 266.414 212.662 267.069 212.662 267.878V269.692C212.662 270.5 213.318 271.156 214.128 271.156H265.472C266.282 271.156 266.939 270.5 266.939 269.692V267.878C266.939 267.069 266.282 266.414 265.472 266.414Z",
    fill: "#64A6FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.104 271.156H128.513L126.887 266.525C124.926 260.924 124.926 254.813 126.887 249.211L128.513 244.581H212.104L210.478 249.211C208.518 254.813 208.518 260.924 210.478 266.525L212.104 271.156Z",
    fill: "#00519E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.191 190.443H186.6V217.034H270.191V190.443Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.159 217.034H141.583L139.958 212.404C137.997 206.802 137.997 200.691 139.958 195.09L141.583 190.459H225.175L223.549 195.09C221.588 200.691 221.588 206.802 223.549 212.404L225.175 217.034H225.159Z",
    fill: "#00519E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.889 190.443H222.545C221.735 190.443 221.078 191.098 221.078 191.907V193.721C221.078 194.53 221.735 195.185 222.545 195.185H273.889C274.699 195.185 275.355 194.53 275.355 193.721V191.907C275.355 191.098 274.699 190.443 273.889 190.443Z",
    fill: "#00519E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.889 212.292H222.545C221.735 212.292 221.078 212.947 221.078 213.756V215.57C221.078 216.379 221.735 217.034 222.545 217.034H273.889C274.699 217.034 275.355 216.379 275.355 215.57V213.756C275.355 212.947 274.699 212.292 273.889 212.292Z",
    fill: "#00519E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.521 217.034H136.929L135.303 212.404C133.343 206.802 133.343 200.691 135.303 195.09L136.929 190.459H220.521L218.895 195.09C216.934 200.691 216.934 206.802 218.895 212.404L220.521 217.034Z",
    fill: "#00305E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.307 163.375H176.715V189.966H260.307V163.375Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.292 189.981H131.7L130.075 185.35C128.114 179.749 128.114 173.638 130.075 168.037L131.7 163.406H215.292L213.666 168.037C211.705 173.638 211.705 179.749 213.666 185.35L215.292 189.981Z",
    fill: "#88BDFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.006 163.375H212.662C211.852 163.375 211.195 164.03 211.195 164.839V166.653C211.195 167.461 211.852 168.117 212.662 168.117H264.006C264.816 168.117 265.472 167.461 265.472 166.653V164.839C265.472 164.03 264.816 163.375 264.006 163.375Z",
    fill: "#88BDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_93_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.006 185.239H212.662C211.852 185.239 211.195 185.895 211.195 186.703V188.517C211.195 189.326 211.852 189.981 212.662 189.981H264.006C264.816 189.981 265.472 189.326 265.472 188.517V186.703C265.472 185.895 264.816 185.239 264.006 185.239Z",
    fill: "#88BDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.636 189.981H127.061L125.435 185.35C123.475 179.749 123.475 173.638 125.435 168.037L127.061 163.406H210.652L209.027 168.037C207.066 173.638 207.066 179.749 209.027 185.35L210.652 189.981H210.636Z",
    fill: "#64A6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_284",
    x: 86.8932,
    y: 0,
    width: 208.462,
    height: 295.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_93_284",
    x: 149.005,
    y: 103.189,
    width: 95.5913,
    height: 38.5913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_93_284",
    x: 183.484,
    y: 103.189,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_93_284",
    x: 183.484,
    y: 125.039,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_93_284",
    x: 163.065,
    y: 130.258,
    width: 95.5913,
    height: 38.5913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_93_284",
    x: 197.544,
    y: 130.258,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_93_284",
    x: 197.544,
    y: 152.107,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_93_284",
    x: 169.202,
    y: 76.1357,
    width: 95.5913,
    height: 38.5913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_93_284",
    x: 203.681,
    y: 76.1357,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_93_284",
    x: 179.834,
    y: 49.083,
    width: 95.5913,
    height: 38.5913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_93_284",
    x: 214.313,
    y: 49.083,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_93_284",
    x: 214.313,
    y: 70.9321,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_93_284",
    x: 161.471,
    y: 25.9453,
    width: 95.5913,
    height: 34.6606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_93_284",
    x: 193.798,
    y: 10.0322,
    width: 67.3928,
    height: 28.5342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_93_284",
    x: 195.95,
    y: 43.8638,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_93_284",
    x: 111.8,
    y: 10,
    width: 147.238,
    height: 24.0146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_93_284",
    x: 158.123,
    y: 211.496,
    width: 95.5913,
    height: 38.5913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_93_284",
    x: 192.603,
    y: 211.496,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_93_284",
    x: 192.603,
    y: 233.345,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_93_284",
    x: 172.183,
    y: 238.548,
    width: 95.5913,
    height: 38.5913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_93_284",
    x: 206.662,
    y: 238.548,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_93_284",
    x: 206.662,
    y: 260.414,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_93_284",
    x: 180.6,
    y: 184.443,
    width: 95.5913,
    height: 38.5913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_93_284",
    x: 215.078,
    y: 184.443,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_93_284",
    x: 215.078,
    y: 206.292,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_93_284",
    x: 170.715,
    y: 157.375,
    width: 95.5913,
    height: 38.5913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_93_284",
    x: 205.195,
    y: 157.375,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_93_284",
    x: 205.195,
    y: 179.239,
    width: 66.277,
    height: 16.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_284",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Teacher);
export default __webpack_public_path__ + "static/media/step1_teacher.edb4ab8990ae413d19008aa9f3ffeedc.svg";
export { ForwardRef as ReactComponent };